import { Typography } from 'antd'
import { TitleProps as _TitleProps } from 'antd/es/typography/Title'

const { Title: _AntTitle } = Typography

type TitleProps = _TitleProps
export function Title(props: TitleProps) {
  return <_AntTitle {...props} />
}
